import Link from 'next/link';
import React from 'react';
import { PostSummary } from '../../../types/shared.types';
import { ArticleCard } from '../../news/ArticleCard';

type Props = {
    articles: PostSummary[];
};

export const LatestNewsCard: React.FC<Props> = ({ articles }) => {
    return (
        <div className="latest-news-card">
            <div className="title-container">
                <h2 className="title">Latest News</h2>
                <Link href={'/news'}>
                    <a className="button blue-button small-button">All News</a>
                </Link>
            </div>
            <div className="content">
                {articles.map((article: PostSummary, index: number) => (
                    <ArticleCard key={`latest-news-card-${index}`} article={article} />
                ))}
            </div>
        </div>
    );
};
